import api from '@/api';
import { create as createQuestionsTree } from '@/helpers/questionsTree/create';
import { MESSAGE_TYPE } from '@/constants/message';
import locales from '@/modules/locales/dict';

export default {
    namespaced: true,
    state: {
        networkTest: {
            data: '',
            isLoaded: false
        },
        feedbackQuestionList: {
            data: [],
            isLoaded: false,
        },
        preset: null,
        cachedFormData: {},
    },
    mutations: {
        setNetworkTestData(state, data) {
            state.networkTest.data = data;
        },
        setNetworkTestLoaded(state) {
            state.networkTest.isLoaded = true;
        },
        setFeedbackQuestionList(state, data) {
            state.feedbackQuestionList.data = data;
        },
        setFeedbackQuestionListLoaded(state) {
            state.feedbackQuestionList.isLoaded = true;
        },
        setPreset(state, preset) {
            state.preset = preset
        },
        setCachedFormData(state, formData) {
            state.cachedFormData = formData
        },
    },
    actions: {
        async fetchFeedbackQuestion({ commit }) {
            commit('message/show', {
                type: MESSAGE_TYPE.WAITING,
                text: locales[this.state.queryParams.lang].message.loading
            }, { root: true });
            try {
                const response = await api.getFeedbackQuestions(this.state.queryParams)
                const questionTree = createQuestionsTree(response?.data?.data)
                commit('setFeedbackQuestionList', questionTree)
            } catch (e) {
                console.error(e)
                commit('setFeedbackQuestionList', [])
            } finally {
                commit('setFeedbackQuestionListLoaded')
                commit('message/hide', null, { root: true });
            }
        },
        fetchPreset({ commit }) {
            return api.getPreset(this.state.queryParams)
                .then(response => {
                    commit('setPreset', response.data.data)
                })
                .catch(e => {
                    console.error(e)
                    commit('setPreset', null)
                })
        }
    },
};
